import { deserialize } from 'cerialize'
import { ServerError, ErrorCode, ResponseMethod } from 'Modules'

export class ResponseError {
	@deserialize public status: ErrorCode
	@deserialize public config: { method: ResponseMethod }
	@deserialize public data: { errors: ServerError[] }

	public get method(): ResponseMethod {
		return this?.config?.method
	}
	public get errors(): ServerError[] {
		return this?.data?.errors
	}
	public getKeys(): string[] {
		return Object.keys(this?.errors[0])
	}
	public setError(key: string, value: string): void {
		this.errors[0][key] = value
	}
}
